import React, {FC} from 'react';

import {Trans} from '../../../../../../shared/helpers/src/internationalization/react';
import {Handler} from '../../../../../../shared/helpers/src/react/reactHelpers';
import {ToolbarButton} from '../../../../../../shared/ui/src/components/buttons/toolbarButton';
import {useUserTheme} from '../../../../../../shared/ui/src/theme/userThemeProvider';

/*
 * Props.
 */

interface ToggleFormattingButtonProps {
  onClick: Handler;
}

/*
 * Component.
 */

export const ToggleFormattingButton: FC<ToggleFormattingButtonProps> = ({onClick}) => {
  const theme = useUserTheme();
  return (
    <ToolbarButton
      iconName="formatting"
      onClick={onClick}
      label={<Trans id="knowledge-base-toggle-formatting">Toggle options</Trans>}
      color={theme.greys.shade80}
      hoverColor={theme.greys.shade80}
    />
  );
};
